/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_State_FreshInputs */

const vi_tea_purchase_state_fresh = /** @type {(inputs: Tea_Purchase_State_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tươi`)
};

/**

* @param {Tea_Purchase_State_FreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_state_fresh = /** @type {((inputs?: Tea_Purchase_State_FreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_State_FreshInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_state_fresh(inputs)
});